module.exports = __webpack_public_path__ + "img/CarpalTunnel-01.6e670335.svg";